"use client";
import {
  Popover,
  PopoverButton,
  PopoverPanel,
  CloseButton,
} from "@headlessui/react";
import { DropdownArrowIcon } from "./dropdownArrowIcon";
import { usePathname, useSearchParams } from "next/navigation";
import { SortItem, sortOptions } from "./sortOptions";
import { useRouter } from "next13-progressbar";

export const SortDropDown = () => {
  const { push } = useRouter();
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const sort =
    sortOptions.find(
      (o) =>
        o.columns.includes(searchParams?.get("sortOrderColumn") || "") &&
        o.order === searchParams?.get("sortOrder")
    ) || sortOptions[0];

  const handleSortChange = (sortOption: any) => {
    const params = new URLSearchParams(searchParams || "");
    params.set("sortOrderColumn", sortOption?.columns);
    params.set("sortOrder", sortOption.order.toString());
    push(`${pathName}?${params.toString()}`);
  };

  return (
    <>
      <Popover className="relative">
        <PopoverButton
          className={[
            "flex",
            "items-center",
            "gap-x-2",
            "w-full",
            "leading-6",
            "text-gray-900",
            "hover:bg-gray-50",
          ].join(" ")}
        >
          <div
            id="sort_drop_outlined"
            className="w-full min-w-[220px] h-[48px] flex flex-row justify-between items-center px-5 py-3 border border-[#1F2A37] rounded-lg"
          >
            <p>{sort.text}</p>
            <DropdownArrowIcon />
          </div>
        </PopoverButton>
        <PopoverPanel
          transition
          className="absolute top-full z-20 max-w-full min-w-[220px] overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-gray-900/5 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
        >
          <div className="">
            {sortOptions.map((o: SortItem, index: number) => (
              <CloseButton className="w-full" key={index}>
                <div
                  className="group relative flex items-center gap-x-6 rounded-lg px-2 py-4 text-sm leading-6 hover:bg-gray-50 cursor-pointer"
                  onClick={() => {
                    handleSortChange(o);
                  }}
                >
                  {o.text}
                </div>
              </CloseButton>
            ))}
          </div>
        </PopoverPanel>
      </Popover>
    </>
  );
};
